import { callZpayFunction } from '../../callZpayFunction';

// 새로운 브라우저 열기
// - type : checkout, pay, order_complete, points
// - isCloseSelf : (선택) true 설정 시 현재 창이 닫히며 새로운 브라우저가 열립니다
// - type 이 매칭되지 않거나 undefined 인 경우 기본 브라우저
export const open = (url: string, title: string, type: string, isCloseSelf = false) => {
  callZpayFunction('open')({ url, title, type, isCloseSelf });
};
